/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { ApplicationDetailPageService } from '../index';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { RENEW_CSME_CERTIFICATE } from '../../api/graphql';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};
export interface IRenewCSMECertificateMethods extends IPluginMethodMap {
  renewCSMECertificate(args: any): Promise<any>;
}

export interface RenewCSMECertificateProps {}

export class RenewCSMECertificateService implements IAgentPlugin {
  readonly methods: IRenewCSMECertificateMethods;

  constructor() {
    this.methods = {
      renewCSMECertificate: this.renewCSMECertificate.bind(this),
    };
  }

  private async renewCSMECertificate(args: any) {
    const srv = getSrv();

    console.log(`csmecertifcate service input data`, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`csmecertifcate service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      console.log(`csmecertifcate service client`, client);
      if (client) {
        console.log('argssss23', args);
        const res = await client.mutation(RENEW_CSME_CERTIFICATE, {
          ...args,
        });
        if (res?.data?.renewCSMECertificate) {
          return res?.data?.renewCSMECertificate;
        }
      } else {
        console.log('error in renew work permit');
      }
    } catch (err: any) {
      console.log('error in renew work permit', err?.message);
      throw err;
    }
  }
}
